// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".search-modal[data-v-dd4b9286]{width:100%}.accordion-enter-active[data-v-dd4b9286],.accordion-leave-active[data-v-dd4b9286]{transition:max-height .5s linear;max-height:100vh;overflow:hidden}.accordion-enter[data-v-dd4b9286],.accordion-leave-to[data-v-dd4b9286]{max-height:0;transition:max-height .5s;overflow:hidden}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
